import { Snackbar } from "@heathmont/moon-core-tw";
import ErrorIcon from "@/components/icons/ErrorIcon";

type ErrorToastProps = {
  isOpen: boolean;
  handleClose: () => void;
};

export const ErrorToast = ({ isOpen, handleClose }: ErrorToastProps) => {
  return (
    <Snackbar
      isOpen={isOpen}
      position="bottom-center"
      onOpenChange={handleClose}
      autoClose={3000}
      className="max-w-sm rounded-xl border border-[#D34327] bg-white p-4 pr-6 text-dark-color !shadow-[0_8px_8px_rgba(0,12,18,0.24)]"
    >
      <ErrorIcon />
      <Snackbar.Content>
        <p className="text-base text-[#D34327]">
          <span className="font-semibold">There was an error.</span> Please try
          again.
        </p>
      </Snackbar.Content>
    </Snackbar>
  );
};
